import React from 'react';
import { BreadCrumb, FooterSection } from '../../../components';
import { FaqInfoData } from '../../../types';
import LookUpIssue from '../LookUpIssue/LookUpIssue';
import HtmlHeader from '../../../components/HtmlHeader';
import { FOOTER_DATA_IRCTC, IRCTC_EXTERNAL_JS } from '../../../../utils/RailsSEOConstants';
import { getStaticPageLoadEvent } from '../../../../utils/omnitureUtils';

type FaqInfoDataProps = {
  data: FaqInfoData;
};

const QuestionPage = ({ data }: FaqInfoDataProps) => {
  return (
    <div className="demoCompsWrap">
      <BreadCrumb breadcrumb={data.template.breadcrumb} visible={false} />
      <div className="appendBottom20">
        <LookUpIssue data={data.data}></LookUpIssue>
      </div>
      <HtmlHeader data={data} />
      <FooterSection template={data.template} />
    </div>
  );
};

QuestionPage.fetchData = async (_, match, urlObj) => {
  const url = `https://rails-junction.redbus.in/knowledgeCenter/apis/seoRailsTopics`;
  let responseData;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ affiliateCode: 'mmt' })
  });
  // eslint-disable-next-line no-console
  console.info('url', url);
  try {
    responseData = await response.json();
  } catch (e) {
    throw new Error('JSON parse exception: ');
  }
  responseData.template = {
    template_name: `route`,
    pageUrl: `https://www.makemytrip.com/railways/irctc-faqs.html`,
    meta_title: `Indian Railways Frequently Asked Questions, IRCTC FAQs – MakeMyTrip`,
    meta_description: `Frequently Answered Questions about Indian Railways. Get answer to your all the queries related to Indian Railways at MakeMytrip.`,
    meta_keywords: `Indian Railways FAQ, Frequent Asked Questions IRCTC`,
    analytics: getStaticPageLoadEvent('seo:rails:Faqs home'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: `FREQUENLY ASKED QUESTIONS Indian Railways`,
    breadcrumb: [
      {
        redirectionUrl: `https://www.makemytrip.com/`,
        displayString: `Home`
      },
      {
        redirectionUrl: `https://www.makemytrip.com/railways/`,
        displayString: `Rails`
      },
      {
        displayString: `Indian Railways FAQ`,
        redirectionUrl: `https://www.makemytrip.com/railways/irctc-faqs.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/irctc-faqs.html`,
    // sub_title: `Following is the list of all the trains running between Delhi to Mumbai Railway Stations:`,
    // eslint-disable-next-line
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_IRCTC-FAQS.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...responseData
  };
};

export default QuestionPage;
